import { alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  '& svg > path': {
    fill: alpha(theme.palette.common.black, 0.4),
  },
}));
